
import { useState } from "react";
import styles from "../HealthChat.module.css";

/* ─── Chat bubble icon ───────────────────────────────────────────────────── */
const FeedbackIcon = ({ size = 52 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <line x1="9" y1="10" x2="15" y2="10" />
    <line x1="9" y1="14" x2="13" y2="14" />
  </svg>
);

/* ─── Star SVG ───────────────────────────────────────────────────────────── */
const StarIcon = ({ filled, size = 32, onClick, onHover, onLeave }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={filled ? "#e86f00" : "none"}
    stroke={filled ? "#e86f00" : "#d1d5db"}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ cursor: "pointer", transition: "all 0.15s" }}
    onClick={onClick}
    onMouseEnter={onHover}
    onMouseLeave={onLeave}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

/* ─── Copy ───────────────────────────────────────────────────────────────── */
const COPY = {
  en: {
    title: "How was your experience?",
    subtitle: "Your feedback helps us improve Avexa",
    rateLabel: "Rate your experience with Avexa today",
    commentLabel: "Any suggestions or comments?",
    commentPlaceholder: "Share your thoughts...",
    submitBtn: "Submit Feedback",
    skipBtn: "Skip for Now",
  },
  hi: {
    title: "आपका अनुभव कैसा रहा?",
    subtitle: "आपकी प्रतिक्रिया हमें Avexa को बेहतर बनाने में मदद करती है",
    rateLabel: "आज Avexa के साथ अपने अनुभव को रेट करें",
    commentLabel: "कोई सुझाव या टिप्पणी?",
    commentPlaceholder: "अपने विचार साझा करें...",
    submitBtn: "प्रतिक्रिया सबमिट करें",
    skipBtn: "अभी के लिए छोड़ें",
  },
  te: {
    title: "మీ అనుభవం ఎలా ఉంది?",
    subtitle: "మీ అభిప్రాయం Avexa ని మెరుగుపరచడంలో మాకు సహాయపడుతుంది",
    rateLabel: "ఈరోజు Avexa తో మీ అనుభవాన్ని రేట్ చేయండి",
    commentLabel: "ఏదైనా సూచనలు లేదా వ్యాఖ్యలు?",
    commentPlaceholder: "మీ ఆలోచనలు పంచుకోండి...",
    submitBtn: "అభిప్రాయం సమర్పించండి",
    skipBtn: "ఇప్పుడు వదిలేయండి",
  },
};

export default function RatingScreen({ lang = "en", onSubmit, onSkip }) {
  const c = COPY[lang] || COPY.en;
  const [rating, setRating]   = useState(0);
  const [hovered, setHovered] = useState(0);
  const [comment, setComment] = useState("");

  const displayRating = hovered || rating;

  return (
    <div className={styles.ratingScreen}>
      {/* Icon */}
      <div className={styles.bookingIconCircle}>
        <FeedbackIcon size={30} />
      </div>

      <div className={styles.ratingTitle}>{c.title}</div>
      <div className={styles.ratingSub}>{c.subtitle}</div>

      {/* Stars */}
      <div className={styles.ratingStarSection}>
        <div className={styles.ratingStarLabel}>{c.rateLabel}</div>
        <div className={styles.ratingStars}>
          {[1, 2, 3, 4, 5].map((n) => (
            <StarIcon
              key={n}
              filled={n <= displayRating}
              size={34}
              onClick={() => setRating(n)}
              onHover={() => setHovered(n)}
              onLeave={() => setHovered(0)}
            />
          ))}
        </div>
      </div>

      {/* Comment */}
      <div className={styles.ratingCommentSection}>
        <div className={styles.ratingCommentLabel}>{c.commentLabel}</div>
        <textarea
          className={styles.ratingTextarea}
          placeholder={c.commentPlaceholder}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
        />
      </div>

      {/* Actions */}
      <button
        className={rating > 0 ? styles.bookingContinueBtn : styles.bookingContinueBtnDisabled}
        style={{ width: "100%" }}
        disabled={rating === 0}
        onClick={() => onSubmit({ rating, comment })}
      >
        {c.submitBtn}
      </button>

      <button className={styles.ratingSkipBtn} onClick={onSkip}>
        {c.skipBtn}
      </button>
    </div>
  );
}
